var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('a',{staticClass:"skip-link",attrs:{"href":"#main-content"}},[_vm._v("跳到主要内容")]),(!_vm.$route.meta.noShell)?_c('app-shell'):_c('div',{staticClass:"bare-view",attrs:{"id":"main-content"}},[_c('router-view')],1),_c('global-audio-player')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }